const testimonials = [
  {
    name: 'John Doe',
    role: 'Agricultural Student',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80',
    content: 'AgriMocks helped me ace my agricultural science exams. The mock tests are incredibly helpful!'
  },
  {
    name: 'Jane Smith',
    role: 'Farm Manager',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80',
    content: 'The study materials are comprehensive and up-to-date. Highly recommended for agriculture professionals.'
  },
  {
    name: 'Mike Johnson',
    role: 'Agricultural Researcher',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80',
    content: 'The platform offers excellent resources for staying current with agricultural practices.'
  }
];

const TestimonialsPage = () => {
  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Student Success Stories</h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">Hear from our community of agricultural professionals</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white dark:bg-gray-900 rounded-[24px] p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4" />
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-gray-600 dark:text-gray-300">{testimonial.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsPage; 